import { axiosInstance } from '../axios/axiosConfig';

const baseUrl = 'Learners';

export const getLearnerDetail = async (id) => {
    return await axiosInstance.get(`/${baseUrl}/${id}`);
}

export const getLearnerDetailByUserId = async (id) => {
    return await axiosInstance.get(`/${baseUrl}/userId/${id}`);
}